import {Subscription} from 'rxjs';

import {AlertTypesEnum} from '../../enums';

export class Alert {
    public subscription: Subscription;

    public index: number;
    public type: AlertTypesEnum;
    public message: string;
    public autoRemovable: boolean;

    constructor(index: number, type: AlertTypesEnum, message: string, autoRemovable: boolean) {
        this.index = index;
        this.type = type;
        this.message = message;
        this.autoRemovable = autoRemovable;
    }
}
